import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { SITEINFO_CHECKLIST } from "./type";

export const getSiteInfo = (siteId=null,gateId=null) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.siteInformationChecklist}?siteId=${siteId}&gateId=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SITEINFO_CHECKLIST,
      payload: data.response.data,
    });
    return true;
  }
};
